'use strict';

import angular from 'angular';
import ApplicationsController from './applications.controller';

export default angular.module('bfastCaptureManagerApp.applications', [])
  .controller('ApplicationsController', ApplicationsController)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/applications/index.js